@if (this.canShowOnCall) {
  <div [style.height.px]="height" [style.width.px]="width ? width : 'auto'">
    <button
      (click)="toggleOnCall()"
      matRipple
      class="celo-button-sm fh"
      [ngClass]="{
        'celo-primary-button': isOnCall,
        'celo-secondary-button': !isOnCall,
      }"
      [disabled]="isSavingOnCall"
      [matTooltip]="isOnCall ? 'You are on call now' : ''"
    >
      @if (isSavingOnCall) {
        <span class="appear_1">Updating</span>
      }
      @if (!isSavingOnCall) {
        <span>ON CALL</span>
      }
    </button>
  </div>
}
